"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function currentWindowHeight(offset) {
    if (offset === void 0) { offset = 0; }
    return window.innerHeight - offset;
}
function currentWindowWidth(offset) {
    if (offset === void 0) { offset = 0; }
    return window.innerWidth - offset;
}
var fitsScreen = function (element, dimensions, offset) {
    if (dimensions === void 0) { dimensions = 'all'; }
    if (offset === void 0) { offset = 0; }
    if (dimensions === 'all') {
        // Check if the element fits the screen for both width and height
        return element.offsetWidth <= currentWindowWidth(offset)
            && element.offsetHeight <= currentWindowHeight(offset);
    }
    if (dimensions === 'width') {
        // Check if the element fits the screen for width
        return element.offsetWidth <= currentWindowWidth(offset);
    }
    if (dimensions === 'height') {
        // Check if the element fits the screen for height
        return element.offsetHeight <= currentWindowHeight(offset);
    }
};
exports.default = fitsScreen;
//# sourceMappingURL=fits-screen.js.map